import React from 'react'
import Translation from '../Translation/cont/Translation'

class DashboardNoPerformancesPanel extends React.Component {
    render() {
        const { isOpen, movies, onClose } = this.props

        return (
            <div className={`db-expand-panel db-expand-panel--accent${isOpen ? ' db-expand-panel--open' : ''}`}>
                <div className="db-panel-head">
                    <span className="db-panel-title db-panel-title--accent text-small-light"><Translation id="dashboard_stat_no_performances_label">No Performances</Translation></span>
                    <span className="db-panel-count db-panel-count--accent text-small-light"><Translation id="dashboard_panel_movies_count" before={`${movies.length} `}>movies</Translation></span>
                    <span className="db-panel-close text-small-light" onClick={onClose}>✕ <Translation id="button_close">Close</Translation></span>
                </div>
                <div className="db-panel-body">
                    <div className="db-panel-grid">
                        {movies.map(movie => (
                            <div key={movie.id} className="db-panel-item">
                                <div
                                    className={`db-pi-chip${movie.posterUrl ? ' db-pi-chip--has-image' : ''}`}
                                    style={movie.posterUrl ? { backgroundImage: `url("${movie.posterUrl}")` } : undefined}
                                />
                                <div className="db-pi-body">
                                    <div className="db-pi-film text-light">{movie.title}</div>
                                    <a className="db-pi-link text-small-light" href={movie.editUrl}><Translation id="dashboard_panel_edit_link">→ Edit</Translation></a>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        )
    }
}

export default DashboardNoPerformancesPanel
